import { createSelector } from '@reduxjs/toolkit';
import { AppBarState } from './reducer';

interface State {
  appBar: AppBarState;
}

const selectAppBar = (state: State) => state.appBar;

export const selectBack = createSelector(selectAppBar, state => state.back);

export const selectTitle = createSelector(selectAppBar, state => state.title);
